import React from "react";
import "./modal.css";
import { Modal } from "react-bootstrap";

export default function CustModal(props) {
  return (
    <Modal
      show={props.show}
      onHide={props.handleClose}
      dialogClassName="modal-dialog-scrollable"
      size={props.modalWidthSize}
      backdrop={props.backdrop}
    >
      <Modal.Header closeButton>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{props.body}</Modal.Body>
      {props?.footerBtn && (
        <Modal.Footer>
          <button variant="secondary" className="btn btn-primary" onClick={props.handleSubmit}>
            {props.footerBtnName}
          </button>
        </Modal.Footer>
      )}
    </Modal>
  );
}
